export default __webpack_public_path__ + "static/media/Artifact.72f3e6bc.png";